"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ingestionArrearsPayloadSchema = void 0;
var constants_1 = require("@hobt/constants");
var ingestion_file_schema_1 = require("./ingestion-file-schema");
exports.ingestionArrearsPayloadSchema = {
    type: 'object',
    additionalProperties: {
        not: true,
        /* eslint-disable-next-line no-template-curly-in-string */
        errorMessage: '- should not have additional property ${0#}',
    },
    required: [
        'submissionID',
        'correspondenceLanguageCode',
        'financialInstitutionCode',
        'reportingPeriod',
        'transitNumber',
        'file',
    ],
    properties: {
        submissionID: {
            type: 'string',
            format: 'uuid',
            errorMessage: 'should follow UUID format 00000000-0000-0000-0000-000000000000 or null',
        },
        correspondenceLanguageCode: {
            type: 'number',
            enum: Object.values(constants_1.Language),
            errorMessage: 'Should equate to a valid Language Enum value',
        },
        financialInstitutionCode: {
            type: 'string',
            minLength: 3,
            maxLength: 3,
            errorMessage: 'Should be a string with a length of 3 characters',
        },
        reportingPeriod: {
            type: 'string',
            format: 'date',
            errorMessage: 'should follow date format YYYY-MM-DD',
        },
        transitNumber: {
            type: 'string',
            minLength: 5,
            maxLength: 5,
            errorMessage: 'Should be a string with a length of 5 characters',
        },
        file: ingestion_file_schema_1.ingestionFileSchema,
    },
};
